import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getHrBlogById, getCurrentUser, strings } from "../utils";
import { BlogBanner } from "../assets/images";
import { Button } from "../components";
import moment from "moment";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userDesignation, setUserDesignation] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedBlog = await getHrBlogById(id);
        setBlog(fetchedBlog);

        const user = await getCurrentUser();
        setUserDesignation(user.designation);
      } catch (err) {
        setError("Blog not found or error fetching the blog.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }
  const capitalizedAuthor =
    blog.author.charAt(0).toUpperCase() + blog.author.slice(1);

  return (
    <div className="py-7 px-6 bg-color-2 overflow-scroll">
      <div className="p-6 bg-white rounded-3xl mb-6">
        <div className="relative">
          <img
            src={BlogBanner}
            alt="Profile"
            className="w-full object-cover rounded-t-[16px]"
          />
          <div className="absolute left-[70px] bottom-[-80px] w-[124px] h-[124px] border-4 border-border rounded-full bg-white">
            <label htmlFor="profileImage" className="cursor-pointer">
              <img
                src={blog.blogImage || "No Image"}
                alt="User"
                className="w-[90px] h-[90px] pl-7 pt-7"
              />
            </label>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <div className="pt-[116px] flex flex-start gap-x-4">
            <div className="flex flex-col items-center px-4 border-r border-border gap-y-4">
              <p className="text-xs font-normal text-color-1">
                {strings["createdBy"]}
              </p>
              <p className="text-base font-semibold">{capitalizedAuthor}</p>
            </div>
            <div className="flex flex-col items-center px-4 border-r border-border gap-y-4">
              <p className="text-xs font-normal text-color-1">
                {strings["blogVersion"]}
              </p>
              <p className="text-base font-semibold">{blog.version}</p>
            </div>
            <div className="flex flex-col items-center px-4 border-r border-border gap-y-4">
              <p className="text-xs font-normal text-color-1">
                {strings["lastUpdated"]}
              </p>
              <p className="text-base font-semibold">
                {moment(blog.updatedAt.toDate()).format("DD MMM YYYY")}{" "}
              </p>
            </div>
          </div>
          <div className="mt-[116px]">
            {(userDesignation === "ADMIN" || userDesignation === "HR") && (
              <Button
                classes="border-primary text-primary !w-full justify-center"
                onClick={() => navigate(`/wikkipedia/edit/${blog.id}`)}
              >
                {strings["editArticle"]}
              </Button>
            )}
          </div>
        </div>

        <div className="pt-8 pb-6">
          <p className="font-semibold text-[30px]">{blog.title}</p>
        </div>

        <div
          className="quill-content-preview"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      </div>
    </div>
  );
};

export default BlogDetails;
